/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Takes an instance of the swiper on init and then listens for tabs. If a tab 
 * event occurs, then set the active slide to match the index.
 * @param {swiper} swiperInstance 
 */

// Update Variant Description on Variant Change
document.addEventListener('variant:changed', function(event) {
  let currentVariant = event.detail.variant; 
  const variants = document.querySelectorAll('.variant__description[data-variant-id]'); //find all the variant descriptions with the data attribute that we added

  variants.forEach( function(variant) {
    variant.style.display = 'none';  //hide all variant descriptions
    
    if(variant.dataset.variantId == currentVariant.id){
      //if current variant unhide the variant description
      variant.style.display = 'block'
    }
    });
});
  

function handleSlideOnTab(swiperInstance) {
  // on tab slide to active index
  slides = swiperInstance.el.querySelectorAll(".swiper-slide");
  Array.from(slides).forEach(function(el, i){
    el.addEventListener('keyup', function(e) {
      if(e.code !== 'Tab') return;
      if(document.activeElement === el) {
        swiperInstance.slideTo(i);
      }
    });
  });
}

/*---slider---*/
new Swiper('.story-slider', {
    // Optional parameters
    direction: 'horizontal',
    spaceBetween: 30,
    slidesPerView: 2,
    allowTouchMove: false,
    observer: true,
    observeParents: true,
    rewind: true,
    autoHeight: true,
    navigation: {
      nextEl: '.post-slider-arrow',
      prevEl: '.post-slider-arrow-prev'
    },
    breakpoints: {
      898: {
        slidesPerView: 2.5,
      },
      1400: {
        slidesPerView: 3.5,
      }
    },
    on: {
      init(swiper) {
        handleSlideOnTab(swiper);
      }
    }
});

/**
 * Takes a swiper instance and reverses the order of the slides
 * @param {swiper} swiperInstance 
 */
function reverseSlides(swiperInstance) {
  const Slider = document.querySelector(swiperInstance.el);
  const Slides = Slider.querySelectorAll(':scope .swiper-slide');
  const slides = Array.from(Slides);

  // remove the slides
  slides.forEach(function(el) {
    el.remove();
  });

  // reverse element order, cheating immutably
  slidesReversed = slides.slice().reverse();

  // add the reversed element back to the DOM
  slidesReversed.forEach(function(el) {
    // .swiper-wrapper is required for swiperjs library, so we can ref it here
    Slider.querySelector(':scope .swiper-wrapper').appendChild(el);
  });
}

const MAX_MOBILE_WIDTH = 640;
const SLIDES_PER_DESKTOP = 3;

const TstSliderFact = function(shouldInitialize = true) {
  return new Swiper('.tst-slider', {
    // Optional parameters
    direction: 'vertical',
    spaceBetween: 30,
    slidesPerView: 2,
    allowTouchMove: false,
    observer: true,
    observeParents: true,
    rewind: true,
    autoHeight: true,
    init: shouldInitialize,
    loop: true,
    navigation: {
      nextEl: '.post-slider-arrow',
      prevEl: '.post-slider-arrow-prev'
    },
    breakpoints: {
      [MAX_MOBILE_WIDTH + 1]: {
        direction: 'horizontal',
        slidesPerView: SLIDES_PER_DESKTOP,
        slidesPerGroup: 1,
        navigation: {
          prevEl: '.post-slider-arrow',
          nextEl: '.post-slider-arrow-prev'
        }
      },
      1242: {
        direction: 'horizontal',
        slidesPerView: 4,
        slidesPerGroup: 1,
      }
    },
    on: {
      init(swiper) {
        if(innerWidth > MAX_MOBILE_WIDTH) {
          swiper.slideTo(-SLIDES_PER_DESKTOP, 0);
        }
      }
    }
  });
};

/**
 * Check the window width and then initialize the Testimonial slider
 */
(function() {
  const tstSlider = TstSliderFact(false);
  if(innerWidth > MAX_MOBILE_WIDTH) {
    reverseSlides(tstSlider);
    tstSlider.init();
  } else {
    tstSlider.init();
  }
})();

new Swiper('.gallery-slider', {
    // Optional parameters
    direction: 'horizontal',
    spaceBetween: 16,
    slidesPerView: 1,
    allowTouchMove: false,
    observer: true,
    observeParents: true,

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
});

/**
 * Takes an animation step fn that handles elapsed time. Animation step is responsible 
 * for returning boolean that denotes if the animation has completed or not. 
 * true = completed, false = not completed.
 * Animation max execution time is 3 seconds!
 * @param {function} animationStep 
 */
function animate(animationStep) {
  const maxExecutionTime = 3000;
  let start, previousTimeStamp;
  let done = false;

  function step(timestamp) {
    if (start === undefined) {
      start = timestamp;
    }
    const elapsed = timestamp - start;

    if (previousTimeStamp !== timestamp) {
      done = animationStep(elapsed);
    }

    if (elapsed < maxExecutionTime) { // Stop the animation after 2 seconds
      previousTimeStamp = timestamp
      !done && window.requestAnimationFrame(step);
    }
  }

  window.requestAnimationFrame(step);
}

/**
 * Animate the stat numbers on the homepage
 */
(function animateNumbers() {
  const numberedElements = document.querySelectorAll('[data-stat-number]');

  Array.from(numberedElements).forEach(function(el) {
    const animationEndTime = 2000;
    function countStat(elapsedTime) {
      speed = el.dataset.statNumber / animationEndTime;
      const counter = Math.min(speed * elapsedTime, el.dataset.statNumber);
      el.innerHTML = Math.round(counter).toLocaleString("en-US");
      return counter >= el.dataset.statNumber;
    }
    
    animate(countStat);
  });
})();


